import { lazy, type ComponentType } from 'react';

const RELOAD_FLAG = 'foodweb_chunk_reload';

// React.lazy wrapper that survives deploys: when a code-split chunk 404s
// because the deploy replaced hashed filenames, reload the page once to pick
// up the new HTML instead of leaving the user with a dead button.
// Same constraint as React.lazy's own signature
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(() =>
    factory()
      .then((module) => {
        sessionStorage.removeItem(RELOAD_FLAG);
        return module;
      })
      .catch((error) => {
        if (typeof window !== 'undefined' && !sessionStorage.getItem(RELOAD_FLAG)) {
          sessionStorage.setItem(RELOAD_FLAG, '1');
          window.location.reload();
        }
        throw error;
      })
  );
}
